module.exports = __webpack_public_path__ + "img/educationcampaign.c18a94f7.png";